export default "__VITE_ASSET__mVHPLWi1__"